import OrderHistory from '../components/OrderHistory';

export default function OrderHistoryPage() {
    return (
        <div>
            <OrderHistory />
        </div>
    );
}
